export default __webpack_public_path__ + "static/media/close.64652deb.svg";